export const PIN_REQUIRED_EVENT = 'okgportal:pin-required';
